import { Button, ButtonProps } from '@mui/material';
import React, { BaseSyntheticEvent } from 'react';
import { ButtonColorProps } from 'types/common';
import NavigationApprovalDialog from '../NavigationApprovalDialog/NavigationApprovalDialog';
import ApprovalDialog from './ApprovalDialog';

interface IApprovalDialogButtonProps {
	onApprove: () => void;
	buttonText: string;
	title: string;
	question: React.ReactNode;
	approveText: string;
	disabled?: boolean;
	color?: ButtonColorProps;
	disableNavigationDialog?: boolean;
}

const ApprovalDialogButton = (
	props: IApprovalDialogButtonProps & ButtonProps
) => {
	const {
		buttonText,
		onApprove,
		disabled,
		disableNavigationDialog,
		title,
		question,
		approveText,
		...rest
	} = props;

	const [open, setOpen] = React.useState(false);

	const handleClick = React.useCallback(
		(e: BaseSyntheticEvent) => {
			e.currentTarget?.blur();
			setOpen(!open);
		},
		[open, setOpen]
	);

	const handleApprove = React.useCallback(() => {
		onApprove();
		setOpen(!open);
	}, [open, setOpen, onApprove]);

	return (
		<>
			{!disableNavigationDialog && (
				<NavigationApprovalDialog hasUnsavedChanges={!disabled} />
			)}
			<Button
				variant="text"
				onClick={handleClick}
				data-testid="approval-dialog-button"
				disabled={disabled}
				{...rest}
			>
				{buttonText}
			</Button>
			{open && (
				<ApprovalDialog
					approveText={approveText}
					question={question}
					title={title}
					onApprove={handleApprove}
					cancelText={intl.tr('button.keepEdit')}
					onCancel={handleClick}
				/>
			)}
		</>
	);
};

ApprovalDialogButton.defaultProps = {
	color: 'inherit',
	disabled: false,
	disableNavigationDialog: false
};

export default ApprovalDialogButton;
